import React from 'react'

import {
    ContainerField,
    ErrorText,
    FieldFormInputLabel,
    FieldFormSelect,
    SelectContent,
} from '../styles'
import { IFieldForm } from '../type'
import { ServicesLabels } from 'src/types'

export const FiltFormSelect = ({
    onBlur,
    value,
    onChange,
    id,
    touched,
    errors,
    label,
    title,
    dataSelect,
    ...rest
}: IFieldForm) => {
    return (
        <ContainerField>
            <FieldFormInputLabel id="demo-simple-select-label">
                {title}
            </FieldFormInputLabel>
            <FieldFormSelect
                variant="standard"
                labelId="demo-simple-select-label"
                id={id}
                label={label}
                onChange={onChange}
                onBlur={onBlur}
                value={value}
                {...rest}
            >
                {dataSelect.map((Data: ServicesLabels) => {
                    return (
                        <SelectContent
                            key={Data.id}
                            value={Data.title}
                            className={'css-pwxzbms'}
                        >
                            {Data.title}
                        </SelectContent>
                    )
                })}
            </FieldFormSelect>
            {errors && touched ? (
                <ErrorText variant={'h4'} fontSize={'small'}>
                    {errors}
                </ErrorText>
            ) : null}
        </ContainerField>
    )
}
